const seoContent = require('../content/seo-content');

const { site, faqItems, getServiceBySlug } = seoContent;

const ogImageUrl = `${site.origin}/og-card.png`;

function absoluteUrl(path) {
  if (!path || path === '/') {
    return `${site.origin}/`;
  }
  return `${site.origin}${path}`;
}

function buildOrganizationJsonLd() {
  return {
    '@type': ['Organization', 'LocalBusiness'],
    '@id': `${site.origin}/#organization`,
    name: site.brandName,
    legalName: site.legalName,
    url: `${site.origin}/`,
    telephone: site.phone,
    email: site.email,
    address: {
      '@type': 'PostalAddress',
      streetAddress: site.address.streetAddress,
      addressLocality: site.address.addressLocality,
      addressRegion: site.address.addressRegion,
      addressCountry: site.address.addressCountry
    },
    areaServed: site.serviceAreas.map((area) => ({
      '@type': 'Place',
      name: area
    })),
    sameAs: site.sameAs,
    vatID: site.vatNumber,
    foundingDate: '2007'
  };
}

function buildWebSiteJsonLd() {
  return {
    '@type': 'WebSite',
    '@id': `${site.origin}/#website`,
    url: `${site.origin}/`,
    name: site.siteName,
    publisher: {
      '@id': `${site.origin}/#organization`
    },
    inLanguage: 'en-ZA'
  };
}

function buildBreadcrumbJsonLd(page) {
  if (page.path === '/') {
    return null;
  }

  const items = [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: `${site.origin}/`
    }
  ];

  if (page.type === 'service') {
    items.push({
      '@type': 'ListItem',
      position: 2,
      name: 'Services',
      item: `${site.origin}/#services`
    });
    items.push({
      '@type': 'ListItem',
      position: 3,
      name: page.h1,
      item: absoluteUrl(page.path)
    });
  } else {
    items.push({
      '@type': 'ListItem',
      position: 2,
      name: page.h1,
      item: absoluteUrl(page.path)
    });
  }

  return {
    '@type': 'BreadcrumbList',
    itemListElement: items
  };
}

function buildServiceJsonLd(page) {
  if (page.type !== 'service') {
    return null;
  }

  const service = getServiceBySlug(page.serviceSlug);
  if (!service) {
    return null;
  }

  return {
    '@type': 'Service',
    '@id': `${absoluteUrl(page.path)}#service`,
    name: service.name,
    serviceType: service.serviceType,
    description: service.description,
    provider: {
      '@id': `${site.origin}/#organization`
    },
    areaServed: site.serviceAreas.map((area) => ({
      '@type': 'Place',
      name: area
    })),
    availableChannel: {
      '@type': 'ServiceChannel',
      serviceUrl: `${site.origin}/`,
      servicePhone: site.phone
    }
  };
}

function buildFAQJsonLd(page) {
  if (page.key !== 'help' && page.type !== 'service') {
    return null;
  }

  const items = page.type === 'service'
    ? (getServiceBySlug(page.serviceSlug) || {}).faqs || []
    : faqItems;

  if (!items.length) {
    return null;
  }

  return {
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer
      }
    }))
  };
}

function buildJsonLd(page) {
  const graph = [
    buildOrganizationJsonLd(),
    buildWebSiteJsonLd(),
    {
      '@type': 'WebPage',
      '@id': `${absoluteUrl(page.path)}#webpage`,
      url: absoluteUrl(page.path),
      name: page.title,
      headline: page.h1,
      description: page.description,
      isPartOf: {
        '@id': `${site.origin}/#website`
      },
      about: {
        '@id': `${site.origin}/#organization`
      },
      inLanguage: 'en-ZA'
    },
    buildBreadcrumbJsonLd(page),
    buildServiceJsonLd(page),
    buildFAQJsonLd(page)
  ].filter(Boolean);

  return {
    '@context': 'https://schema.org',
    '@graph': graph
  };
}

module.exports = {
  ogImageUrl,
  buildJsonLd,
  buildOrganizationJsonLd,
  buildWebSiteJsonLd,
  buildBreadcrumbJsonLd,
  buildServiceJsonLd,
  buildFAQJsonLd
};
